import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <img src="/patacat_logo.png" alt="patacat" className="nav-logo" />
          <span className="nav-title">Patent Portfolio Catalogue</span>
        </div>
        <ul className="nav-links">
          <li>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/catalogue" className={location.pathname === '/catalogue' ? 'active' : ''}>
              Catalogue
            </Link>
          </li>
          <li>
            <Link to="/search" className={location.pathname === '/search' ? 'active' : ''}>
              Search
            </Link>
          </li>
          <li>
            <Link to="/navigation" className={location.pathname === '/navigation' ? 'active' : ''}>
              Portfolio Navigation
            </Link>
          </li>
          <li>
            <Link to="/pipeline" className={location.pathname.startsWith('/pipeline') ? 'active' : ''}>
              Source Data Selection & Processing
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
